/** Programma di audit (AUD-F2.14): modelli Word in Amministrazione, programma compilato e invio sull'audit. */
import { useQuery } from "@tanstack/react-query";
import type { AuditDetailDto, AuditProgrammeDocDto, ProgrammeModelDto, ProgrammeSectionDef, ProgrammeSendResultDto, ProgrammeTemplateDto, ProgrammeTemplateUploadDto, ProgrammeValues } from "@audit-plan/shared";
import { api, apiUrl } from "./client";
import { putXhr, sha256Hex } from "./evidence";

const DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export const programmeTemplateUrl = () => apiUrl("/programme-templates/active/download");

export function useProgrammeTemplates(enabled = true) {
  return useQuery({ queryKey: ["programme-templates"], queryFn: () => api.get<ProgrammeTemplateDto[]>("/programme-templates"), enabled });
}

export async function uploadProgrammeTemplate(file: File, note: string): Promise<ProgrammeTemplateDto> {
  const sha256 = await sha256Hex(file);
  const up = await api.post<ProgrammeTemplateUploadDto>("/programme-templates/upload-url", { name: file.name, size: file.size, sha256, note });
  const headers = new Headers(up.headers);
  if (!headers.has("content-type")) headers.set("content-type", DOCX);
  await putXhr(up.url, file, headers, {});
  return api.post<ProgrammeTemplateDto>(`/programme-templates/${up.id}/confirm`);
}

export const activateProgrammeTemplate = (id: string) => api.post<ProgrammeTemplateDto>(`/programme-templates/${id}/activate`);
export const setProgramme = (auditId: string, evidenceId: string | null) => api.put<AuditDetailDto>(`/audits/${auditId}/programme`, { evidenceId });
export const setProgrammeSent = (auditId: string, sentAt: string | null, sentTo = "") => api.put<AuditDetailDto>(`/audits/${auditId}/programme/sent`, { sentAt, sentTo });

/* ---------- programma compilato nel tool (AUD-F2.14b) ---------- */

export function useProgrammeModels(enabled = true) {
  return useQuery({ queryKey: ["programme-models"], queryFn: () => api.get<ProgrammeModelDto[]>("/programme-models"), enabled });
}
export const saveProgrammeModel = (b: { title: string; sections: ProgrammeSectionDef[]; note: string }) => api.post<ProgrammeModelDto>("/programme-models", b);
export const activateProgrammeModel = (id: string) => api.post<ProgrammeModelDto>(`/programme-models/${id}/activate`);

export function useProgrammeDoc(auditId: string, enabled = true) {
  return useQuery({ queryKey: ["programme-doc", auditId], queryFn: () => api.get<AuditProgrammeDocDto>(`/audits/${auditId}/programme-doc`), enabled });
}
export const saveProgrammeDoc = (auditId: string, values: ProgrammeValues) => api.put<AuditProgrammeDocDto>(`/audits/${auditId}/programme-doc`, { values });
export const issueProgrammeDoc = (auditId: string, lang: "it" | "en") => api.post<AuditProgrammeDocDto>(`/audits/${auditId}/programme-doc/issue`, { lang });
export const sendProgrammeDoc = (auditId: string, lang: "it" | "en", to: { name: string; email: string }[]) => api.post<ProgrammeSendResultDto>(`/audits/${auditId}/programme-doc/send`, { lang, to });
export const sendProgrammeTest = (auditId: string, lang: "it" | "en") => api.post<{ to: string; mailMode: string }>(`/audits/${auditId}/programme-doc/send-test`, { lang });
export const programmePreviewUrl = (auditId: string, lang: "it" | "en") => apiUrl(`/audits/${auditId}/programme-doc/preview.pdf`, { lang });
